import React from "react";
import { Mail, Instagram, Phone, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";
import { PolarisStar } from "@/components/site/PolarisStar";

export const Footer = () => {
  return (
    <footer id="site-footer" className="bg-[#fbf7f1] border-t border-[#e4dccf]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <h3 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight max-w-md leading-tight">
              ¿Listo para que tu voz se escuche?
            </h3>
            <a
              href="#agendar"
              data-testid="footer-cta"
              className="mt-6 inline-flex items-center gap-2 bg-[#2b2a33] text-white font-semibold px-6 py-3.5 rounded-full hover:bg-[#ff5c49] transition-colors"
            >
              Agendar llamada <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-widest text-[#bcb4a6]">Explora</p>
            <ul className="mt-4 space-y-2.5">
              {[
                ["Soluciones", "#soluciones"],
                ["Servicios", "#servicios"],
                ["Experiencia", "#experiencia"],
                ["Agendar", "#agendar"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="text-[#6b6873] hover:text-[#2b2a33] transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-widest text-[#bcb4a6]">
              Contacto
            </p>
            <div className="mt-4 space-y-3">
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email"
                className="flex items-center gap-2 text-[#6b6873] hover:text-[#2b2a33] transition-colors"
              >
                <Mail className="w-4 h-4" /> {BRAND.email}
              </a>
              <a
                href={`https://wa.me/${BRAND.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-2 text-[#6b6873] hover:text-[#2b2a33] transition-colors"
              >
                <Phone className="w-4 h-4" /> +1 (407) 721-1579
              </a>
              <a
                href="#"
                className="flex items-center gap-2 text-[#6b6873] hover:text-[#2b2a33] transition-colors"
              >
                <Instagram className="w-4 h-4" /> @polaris
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#e4dccf] flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <PolarisStar className="w-6 h-6" />
            <span className="font-display text-lg font-extrabold tracking-tight">{BRAND.name}</span>
            <span className="text-sm text-[#6b6873]">· {BRAND.role}</span>
          </div>
          <p className="text-sm text-[#bcb4a6]">
            © {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
